"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const form_data_1 = __importDefault(require("form-data"));
const __1 = require("..");
class OMFile extends __1.OMObject {
    constructor(object) {
        super(object);
        this.mimetype = object.mimetype || "";
        this.size = object.size || 0;
        this.preview = object.preview || "";
        this.url = object.url || "";
        this.file = object.file;
    }
    static FromJson(object) {
        const fileObjectProperties = Object.assign({}, object, super.FromJson(object));
        return new OMFile(fileObjectProperties);
    }
    upload() {
        try {
            __1.OMUniverse.shared.touch(this);
            const command = new OMFile.UploadCommand(this);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
OMFile.Type = "om_file";
OMFile.UploadCommand = class UploadCommand extends __1.Command {
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            const file = this.receiver.actualObject;
            if (file.file === undefined) {
                return Promise.reject(new Error("Expecting file"));
            }
            const formData = new form_data_1.default();
            formData.append("file", file.file);
            const resp = yield __1.OMUniverse.shared.apiClient.send({
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                method: "PUT",
                url: `${this.typeClass.Path}/${this.receiver.id}`,
            });
            // Remove File after successful upload
            file.file = undefined;
            __1.OMUniverse.shared.touch(file);
            return resp;
        });
    }
};
exports.default = OMFile;
//# sourceMappingURL=OMFile.js.map